'use es6';

import { Component } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import enviro from 'enviro';
import { setAuth } from 'simple-menus-core/actions/Auth';
import configureStore from 'simple-menus-lib/utils/redux/configureStore';
import DragDropContext from 'simple-menus-lib/components/dnd/DragDropContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function configureSimpleMenu({
  withDragDropContext = false,
  httpClient
}) {
  const store = configureStore({}, httpClient);
  if (enviro.isQa()) {
    window.SimpleMenusStore = store;
  }
  class SimpleMenusProvider extends Component {
    componentDidMount() {
      const {
        auth
      } = this.props;
      store.dispatch(setAuth(auth));
    }
    render() {
      const {
        children
      } = this.props;
      return /*#__PURE__*/_jsx(Provider, {
        store: store,
        children: children
      });
    }
  }
  SimpleMenusProvider.propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired
  };
  if (withDragDropContext) {
    return DragDropContext(SimpleMenusProvider);
  }
  return SimpleMenusProvider;
}